import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { closeSidebar } from "../../store/redux_auth/authSlice";

function PrivateMobileNavigation() {
  const location = useLocation();
  const dispatch = useDispatch();

  // 1. Grab segments from Redux
  const segments = useSelector((state) => state.auth.currentSegments || []);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => document.body.classList.remove("no-scroll");
  }, [isExpanded]);

  // If there are no segments, we don't render the bar at all
  if (segments.length === 0) return null;

  // 2. Logic for "3 + More"
  const visibleSegments = segments.slice(0, 3);
  const hiddenSegments = segments.slice(3);
  const hasMore = segments.length > 3;

  const closeExpanded = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsExpanded(false);
      setIsClosing(false);
    }, 350);
  };

  // Helper to determine if a segment is active
  const checkIsActive = (path) => {
    const current = location.pathname + location.search;
    return current === path;
  };

  return (
    <div className="mobile-bottom-nav">
      <div className="mobile-nav-main">
        {/* Render first 3 segments */}
        {visibleSegments.map((segment, index) => {
          const isActive = checkIsActive(segment.path);

          // Check if segment is "Spending" by label or path
          const isSpending =
            segment.text?.toLowerCase() === "spending" ||
            segment.path?.toLowerCase().includes("spending");

          // Dynamic icon dimensions & rotation style
          const customIconStyle = {
            ...(segment.iconWidth && { width: segment.iconWidth }),
            ...(segment.iconHeight && { height: segment.iconHeight }),
            ...(isSpending && { transform: "rotate(180deg)" }),
          };

          return (
            <div
              className="mobile-nav-item"
              key={index}
              style={{
                borderTop: `3px solid ${isActive ? "#ffffff" : "#004789"}`,
              }}
            >
              <Link
                to={segment.path}
                className={`mobile-nav-link ${isActive ? "active" : ""}`}
              >
                <img
                  src={isActive ? segment.activeIcon : segment.normalIcon}
                  alt={segment.text}
                  className="mobile-nav-icon"
                  style={
                    Object.keys(customIconStyle).length > 0
                      ? customIconStyle
                      : undefined
                  }
                />
                <span className="mobile-nav-label">{segment.text}</span>
              </Link>
            </div>
          );
        })}

        {/* More Button (Only if 4+ segments exist) */}
        {hasMore && (
          <div className="mobile-nav-item">
            <button
              className="mobile-nav-link more-button"
              onClick={() => setIsExpanded(true)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/more_three_dots.svg`}
                alt="More"
                className="mobile-nav-icon"
              />
              <span className="mobile-nav-label">More</span>
            </button>
          </div>
        )}
      </div>

      {/* Expanded Drawer for remaining segments */}
      {isExpanded && (
        <>
          <div
            className={`sidebar-overlay active ${isClosing ? "closing" : ""}`}
            onClick={closeExpanded}
          />

          <div className={`mobile-nav-expanded ${isClosing ? "closing" : ""}`}>
            <button
              className="mobile-nav-expanded-close"
              onClick={closeExpanded}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/arrow_down_blue_light.svg`}
                alt="Close"
              />
            </button>

            <div className="mobile-nav-expanded-content">
              <div className="mobile-nav-expanded-section">
                <h3>More</h3>
                {hiddenSegments.map((segment, index) => {
                  const isActive = checkIsActive(segment.path);

                  // Check if segment is "Spending" by label or path
                  const isSpending =
                    segment.text?.toLowerCase() === "spending" ||
                    segment.path?.toLowerCase().includes("spending");

                  // Dynamic icon dimensions & rotation style
                  const customIconStyle = {
                    ...(segment.iconWidth && { width: segment.iconWidth }),
                    ...(segment.iconHeight && { height: segment.iconHeight }),
                    ...(isSpending && { transform: "rotate(180deg)" }),
                  };

                  return (
                    <Link
                      key={index}
                      to={segment.path}
                      className="mobile-nav-expanded-link"
                      onClick={closeExpanded}
                    >
                      <img
                        src={isActive ? segment.activeIcon : segment.normalIcon}
                        alt={segment.text}
                        className="mobile-nav-expanded-icon"
                        style={
                          Object.keys(customIconStyle).length > 0
                            ? customIconStyle
                            : undefined
                        }
                      />
                      {segment.text}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PrivateMobileNavigation;
